import React from "react";
import { Toolbar } from "../../layout/Toolbar/Toolbar";
import { FormularioCalificacion } from "../../components/EtapasDeCalificacion/FormularioCalificacion";
import { useParams } from "react-router-dom";

export const VerCalificacion = () => {
  const { idCalificacion } = useParams();
  console.log(idCalificacion);

  let toolbarEnlaces = [
    {
      muted: "true",
      to: "/",
      title: "Home",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "false",
      to: null,
      title: "VER CALIFICACIÓN",
      bullet: "false",
    },
  ];

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Toolbar title=" - VER CALIFICACIÓN" enlaces={toolbarEnlaces} />

      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder text-dark">
                      Calificación
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                  <FormularioCalificacion calificacion={idCalificacion} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
